import { render, staticRenderFns } from "./add-cmt.vue?vue&type=template&id=0b4c8b91&scoped=true&"
import script from "./add-cmt.vue?vue&type=script&lang=js&"
export * from "./add-cmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c8b91",
  null
  
)

export default component.exports